/**
 * Shared layout constants for the AnimationPreview editor.
 * These values define the panel geometry and must stay in sync across all modules.
 */

import { CANVAS_WIDTH, CANVAS_HEIGHT } from '@/config/GameConfig';

export const SIDEBAR_W = 200;
export const TIMELINE_H = 160;
export const RIGHT_PANEL_W = 160;
export const WORK_W = CANVAS_WIDTH - SIDEBAR_W - RIGHT_PANEL_W; // 840
export const WORK_Y = (CANVAS_HEIGHT - TIMELINE_H) / 2 - 10;

// Sheet view (left): full spritesheet with grid + bbox
export const SHEET_W = Math.floor(WORK_W * 0.55); // ~462
export const SHEET_X = SIDEBAR_W + SHEET_W / 2;
export const SHEET_Y = WORK_Y;
export const SHEET_SIZE = Math.min(SHEET_W - 20, CANVAS_HEIGHT - TIMELINE_H - 100);

// Frame preview (right): cropped/baked result
export const FRAME_W = WORK_W - SHEET_W; // ~378
export const FRAME_X = SIDEBAR_W + SHEET_W + FRAME_W / 2;
export const FRAME_Y = WORK_Y;
export const FRAME_SIZE = Math.min(FRAME_W - 20, CANVAS_HEIGHT - TIMELINE_H - 100);

// Legacy compat aliases
export const PREVIEW_SIZE = FRAME_SIZE;
export const PREVIEW_X = FRAME_X;
export const PREVIEW_Y = FRAME_Y;
